/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { verticalGridlinesStyles } from './themes/TimeComponentStyles.css';

type Props = {
  width: number;
  height: number;
  positions: number[];
  variant: 'major' | 'minor';
};

export function TimeComponentVerticalGridlines({ width, height, positions, variant }: Props) {
  const cmd = positions.map((p) => `M${p},0 V${height}`).join(' ');
  return (
    <svg width={width} height={height}>
      <path class={verticalGridlinesStyles[variant]} d={cmd} />
    </svg>
  );
}
